module.exports = __webpack_public_path__ + "img/circle-caret-left.d2620f31.svg";